"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackHubspotNavigation = void 0;
// Tells HubSpot about a client-side (SPA) navigation. HubSpot's tracking script only reacts to full
// page loads: it records one page view and fetches CTA targeting (web interactives) for the initial
// URL only. Call this after every client-side route change, but not for the initial load, which
// initHubspot() and HubSpot itself already cover. Framework-agnostic: each site wires it to its own
// router event (Astro astro:page-load, Gatsby onRouteUpdate).
// HubSpot's own consent banner and the doNotTrack command pushed by initHubspot() still govern what
// trackPageView records.
// See docs/specs/2026-09-29-hubspot-cta-astro-navigation.md.
const trackHubspotNavigation = () => {
    const { pathname, search, hash } = window.location;
    // Commands queue on the array until HubSpot's script loads and drains it.
    const hsq = (window._hsq = window._hsq || []);
    hsq.push(['setPath', `${pathname}${search}${hash}`]);
    hsq.push(['trackPageView']);
    if (window.HubSpotCallsToActions) {
        window.HubSpotCallsToActions.refresh();
        return;
    }
    window.hsCallsToActionsReady = window.hsCallsToActionsReady || [];
    window.hsCallsToActionsReady.push(() => window.HubSpotCallsToActions?.refresh());
};
exports.trackHubspotNavigation = trackHubspotNavigation;
